import { useSelector, useDispatch } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';

import { logout } from '../redux/login';
import { FC, PropsWithChildren } from 'react';

type State = {
	login: {
		loggedinAsAdmin: boolean;
		loggedin: boolean;
		loggedinAsSupervisor: boolean;
	};
	signup: {
		isMobileWebView: boolean;
	};
};

export const DefaultAuthGuard: FC<PropsWithChildren<any>> = (props) => {
	const location = useLocation();
	const dispatch = useDispatch();
	const admin = useSelector((state: State) => state.login.loggedinAsAdmin);
	const authenticated = useSelector((state: State) => state.login.loggedin);
	const isMobileWebview = useSelector((state: State) => state.signup.isMobileWebView);
	const supervisor = useSelector((state: State) => state.login.loggedinAsSupervisor);

	if (!authenticated) {
		return props.children;
	}

	const [, path, search] = location.search.split('?');
	const params = new URLSearchParams(path);
	if (params.has('redirectTo')) {
		const queryString = search ? `?${search}` : '';
		const newURL = `${params.get('redirectTo')}${queryString}`;
		return <Redirect to={newURL} />;
	}

	if (supervisor) {
		return <Redirect to="/supervisor/dashboard" />;
	}

	if (admin) {
		return <Redirect to="/admin" />;
	}

	if (isMobileWebview) {
		dispatch(logout());
		return;
	}

	return <Redirect to="/nurse/shifts/accepted" />;
};
